module.exports = __webpack_public_path__ + "img/Page1B.b7b00ad8.jpg";